import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './StyledContainer.module.css';

const bindClasses = classNameBind.bind(styles);

const StyledContainer = ({
  children,
  dataId,
  border,
  padding,
  backgroundImage,
  backgroundColor,
  fullHeight,
  withoutTopPadding,
  withShadow,
  rounded,
}) => (
  <div
    className={bindClasses(
      'wrapper',
      `padding-${padding}`,
      `background-image-${backgroundImage}`,
      `background-color-${backgroundColor}`,
      border.includes('left') && 'border-left',
      border.includes('right') && 'border-right',
      border.includes('top') && 'border-top',
      border.includes('bottom') && 'border-bottom',
      {
        fullHeight,
        withoutTopPadding,
        withShadow,
        rounded,
      },
    )}
    data-ppuc-id={dataId}
  >
    {children}
  </div>
);

StyledContainer.defaultProps = {
  dataId: 'StyledContainer',
  border: [],
  padding: 'none',
  backgroundImage: 'none',
  backgroundColor: 'none',
  fullHeight: false,
  withoutTopPadding: false,
  withShadow: false,
  rounded: false,
};

export default StyledContainer;
